/*------------------------------------*\
    MODULES
\*------------------------------------*/
import loadGoogleMapsApi from "load-google-maps-api";
import { debounce } from "debounce";

/*------------------------------------*\
    GOOGLE MAP
\*------------------------------------*/
class GoogleMap {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    /*-------------------------------------------------*\
        INIT
    \*-------------------------------------------------*/
    init() {
        let self = this;
        let mapContainer = self.elem.querySelector('.js-google-map');
        let apiKey = self.elem.getAttribute('data-key');
        let center = {
            lat: parseFloat(self.elem.getAttribute('data-lat')),
            lng: parseFloat(self.elem.getAttribute('data-lng'))
        };

        // Load the Google Maps API, passing in our API key
        loadGoogleMapsApi({ key: apiKey }).then(function (googleMaps) {

            // Create the map options
            let mapOptions = {
                zoom: 15,
                center: center,
                disableDefaultUI: true,
                zoomControl: true
            };

            // Create the map
            let map = new googleMaps.Map(mapContainer, mapOptions);

            // Create the marker image
            let image = {
                url: '/assets/images/map-marker.png',
                size: new googleMaps.Size(34, 57),
                origin: new googleMaps.Point(0, 0),
                anchor: new googleMaps.Point(16, 50)
            };

            // Create the bounds object, which will be configure later based on the marker locations
            let bounds = new googleMaps.LatLngBounds();

            // Create the marker object
            let marker = new googleMaps.Marker({
                position: center,
                map: map,
                icon: image,
                animation: google.maps.Animation.DROP
            });

            // Work out the area of the map containing markers
            bounds.extend(marker.position);

            // Center the map on window resize
            window.onresize = debounce(centerMap, 200);

            function centerMap() {
                map.setCenter(bounds.getCenter());
            }

        }).catch(function (error) {
            console.error(error)
        });
    }
}

export default GoogleMap;
